import { useState } from 'react';
import { reviews } from '../../../mocks/hotelData';

export default function Reviews() {
  const [showAll, setShowAll] = useState(false);
  const displayedReviews = showAll ? reviews : reviews.slice(0, 3);

  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">이용 후기</h2>
      
      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <div className="flex items-center gap-6">
          <div className="text-center">
            <div className="text-5xl font-bold text-gray-900 mb-1">8.2</div>
            <div className="text-sm text-gray-600">매우 좋음</div>
          </div>
          <div className="flex-1">
            <div className="space-y-2">
              {[
                { label: '청결도', score: 8.5 },
                { label: '직원 친절도', score: 8.8 },
                { label: '편의시설', score: 8.0 },
                { label: '위치', score: 9.2 }
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-sm text-gray-600 w-24">{item.label}</span>
                  <div className="flex-1 bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-teal-600 h-2 rounded-full"
                      style={{ width: `${(item.score / 10) * 100}%` }}
                    ></div>
                  </div>
                  <span className="text-sm font-medium text-gray-900 w-8">{item.score}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4 mb-6">
        {displayedReviews.map((review) => (
          <div key={review.id} className="border border-gray-200 rounded-lg p-5">
            <div className="flex items-start justify-between mb-3">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <span className="font-bold text-gray-900">{review.userName}</span>
                  <span className="text-sm text-gray-500">{review.country}</span>
                </div>
                <div className="text-xs text-gray-500">{review.date}</div>
              </div>
              <div className="bg-teal-600 text-white px-3 py-1 rounded-lg font-bold text-sm">
                {review.rating}
              </div>
            </div>
            
            <p className="text-sm text-gray-700 leading-relaxed mb-3">{review.comment}</p>
            
            <button className="flex items-center gap-2 text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
              <i className="ri-thumb-up-line"></i>
              <span>도움이 됨 ({review.helpful})</span>
            </button>
          </div>
        ))}
      </div>

      {reviews.length > 3 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="w-full border border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
        >
          {showAll ? '접기' : `모든 후기 보기 (${reviews.length}개)`}
        </button>
      )}
    </div>
  );
}